import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * 登録済みレコード数取得API
 * @param {string}fieldsId: 現場ID
 * */
const registeredCount = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldsId}/field_worker_image_statuses/registered_count`
    ),
  });
};

export const fieldWorkerImageStatusesApi = {
  registeredCount,
};

export default fieldWorkerImageStatusesApi;



// WEBPACK FOOTER //
// ./src/services/fieldWorkerImageStatuses/FieldWorkerImageStatusesApi.js